// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"230":"component---src-pages-index-jsx","532":"styles"}[chunkId] + "-" + {"230":"746ac1afab032985227e","532":"e76467e7234bf3091520"}[chunkId] + ".js";
};